LS.analytics = {
	/**
	 * Initialize module
	 */
	init() {
		const scope = this;

		scope.queue = [];

		scope.trackUrl = $.get('papiUrl') + '/track';

		scope.identify();
		scope.view();

		$.events.on('a', 'click', (e, el) => {
			const url = el.href;

			if (
				el.dataset.type ||
				url.startsWith('tel:') ||
				url.includes('landsearch')
			) {
				return;
			}

			scope.event('outbound', {
				target: url
			});
		}, {
			delegate: '$wrapper'
		});

		if (Math.random() >= 0.999) {
			scope.record();
		}
	},

	/**
	 * Track page view
	 */
	view() {
		const id = $.context('id');
		const params = id ?
			{} : LS.filters.get();
		const loc = LS.location.context();

		params.scheme = LS.common.isDark() ?
			'dark' : 'light';

		if (id) {
			params.id = id;
		}

		['ppa', 'price', 'size', 'space', 'year'].forEach(key => {
			if (! params[key]) {
				return;
			}

			const max = params[key].max;
			const min = params[key].min;

			if (max) {
				params[key + '_max'] = max;
			}

			if (min) {
				params[key + '_min'] = min;
			}

			delete params[key];
		});

		if (loc) {
			Object.assign(params, loc);
		}

		this.event('page_view', params);
	},

	/**
	 * Track event
	 *
	 * @param {Object} event
	 * @param {Object} [options]
	 * @param {$} [options.key]
	 * @param {Boolean} [options.send]
	 * @param {$} [options.source]
	 */
	track(event, options) {
		this.process(event, options);
	},

	/**
	 * Send event
	 *
	 * @param {String} name
	 * @param {Object} [params]
	 */
	event(name, params) {
		params ?
			this.push('event', name, params) :
			this.push('event', name);
	},

	/**
	 * Push data
	 * Intentional function
	 */
	push: function() {
		dataLayer.push(arguments);
	},

	/**
	 * Send events
	 */
	send() {
		if (window.crawler) {
			return;
		}

		const scope = this;
		const events = scope.queue;

		if (! events.length) {
			return;
		}

		scope.queue = [];

		const data = {
			events: events
		};

		scope.sent = true;

		if (navigator.sendBeacon) {
			try {
				if (navigator.sendBeacon(scope.trackUrl, JSON.stringify(data))) {
					return;
				}
			} catch (e) {
				//
			}
		}

		$.fetch.request({
			async: false,
			data: data,
			json: true,
			method: 'post',
			url: scope.trackUrl,
			error: xhr => {
				LS.log.issue('TrackError', xhr.responseText, null, {
					first: events[0],
					total: events.length
				});
			}
		});
	},

	/**
	 * Format dataLayer data
	 *
	 * @param {String} type
	 * @param {String} target
	 * @param {String} [method]
	 */
	interact(type, target, method) {
		const data = {
			type: type,
			target: target
		};

		if (method) {
			data.method = method;
		}

		this.event('interact', data);
	},

	/**
	 * Process event for submission
	 *
	 * @param {Object} event
	 * @param {Object} [options]
	 */
	process(event, options) {
		if (window.crawler) {
			return;
		}

		const scope = this;

		options = Object.assign({
			context: null,
			namespace: 'analytics',
			send: true
		}, options);

		event.source = 'web';
		event.time = new Date().toISOString();
		event.uid = scope.uid;

		if (! scope.validate(event)) {
			LS.log.issue('TrackError', 'Invalid', null, event);

			return;
		}

		if (
			event.category !== 'message' &&
			event.category !== 'phone'
		) {
			scope.queue.push(event);
		}

		scope.integrate(event, options);

		if (options.send) {
			scope.send();
		}
	},

	/**
	 * Validate event attributes
	 *
	 * @param {Object} event
	 * @returns {Boolean}
	 */
	validate(event) {
		if (
			event.target === 'listing' ||
			event.target === 'profile'
		) {
			if (! event.id) {
				return false;
			}
		}

		return true;
	},

	/**
	 * Set user identity
	 */
	identify() {
		const scope = this;

		scope.user = scope.user || {};
		scope.uid = LS.user.uid();

		const location = LS.location.get(true);

		if (location) {
			scope.attribute(location);
		}

		const fn = () => {
			scope.process({
				action: 'identify',
				attributes: scope.user
			}, {
				send: false
			});
		};

		// Inject authenticated context when available
		$.observe('user', data => {
			// let send;

			if (data.location && ! scope.user.location) {
				// send = true;

				scope.attribute(data.location);
			}

			if (data.account) {
				// send = true;

				scope.user.id = data.account.id;
			}

			// TODO resend?
			// if (send && scope.sent) {
			// 	fn();
			// }
		}, {
			init: true
		});

		fn();
	},

	/**
	 * Set location attributes
	 *
	 * @param {Object} location
	 */
	attribute(location) {
		const user = this.user;

		user.latitude = location.latitude;
		user.longitude = location.longitude;

		if (location.slug) {
			user.location = location.slug;
		}
	},

	/**
	 * Record session
	 */
	record() {
		const scope = this;

		if (scope.replay || window.crawler || $.env() !== 'production' || LS.user.restricted()) {
			return;
		}

		scope.replay = true;

		$.assets.load({
			js: `https://browser.sentry-cdn.com/${window.debug.version}/bundle.replay.logs.metrics.min.js`,
			success: () => {
				debug.init(true);
			}
		});
	},

	/**
	 * Send data to external service
	 *
	 * @param {Object} event
	 * @param {Object} options
	 */
	integrate(event, options) {
		const integrations = this.integrations;

		Object.keys(integrations).forEach(name => {
			LS.util.idle(() => {
				integrations[name].send(event, options);
			});
		});
	},

	/**
	 * Transform standard data for ListHub
	 *
	 * @param {Object} event
	 * @param {Object} map
	 * @returns {*}
	 */
	transform(event, map) {
		const target = map[event.target];
		const matches = [];

		let action;

		if (! target) {
			return;
		}

		action = target[event.action];

		if (! action) {
			return;
		}

		for (const [ev, obj] of Object.entries(action)) {
			if (Object.keys(obj).every(prop => {
				if (prop.includes('.')) {
					const parts = prop.split('.');

					return event[parts[0]][parts[1]] === obj[prop];
				}

				return event[prop] === obj[prop];
			})) {
				matches.push(ev);
			}
		}

		return matches.length ?
			matches : null;
	},

	/**
	 * Define the available service integrations
	 */
	integrations: {
		ga: {
			/**
			 * Define static event mappings
			 */
			map: {
				listing: {
					click: {
						call: {
							category: 'phone'
						},
						favorite: {
							category: 'save'
						},
						link: {
							category: 'link'
						},
						print: {
							category: 'print'
						},
						share: {
							category: 'share'
						}
					},
					watch: {
						play: {
							category: 'play'
						}
					},
					submit: {
						message: {
							category: 'message'
						}
					}
				},
				profile: {
					click: {
						call: {
							category: 'phone'
						},
						link: {
							category: 'link'
						},
						share: {
							category: 'share'
						}
					},
					submit: {
						message: {
							category: 'message'
						}
					}
				}
			},

			/**
			 * Send event data to Google Analytics
			 *
			 * @param {Object} event
			 */
			send(event) {
				const matches = LS.analytics.transform(event, this.map);

				if (! matches) {
					return;
				}

				matches.forEach(match => {
					const params = {};

					if (event.id) {
						params.id = event.id;
					}

					if (event.segment) {
						params.segment = event.segment;
					}

					LS.analytics.event(event.target + '_' + match, params);
				});
			}
		},

		listhub: {
			/**
			 * Define static event mappings
			 */
			map: {
				listing: {
					click: {
						AGENT_PHONE_CALL: {
							category: 'phone'
						},
						LISTING_SAVED: {
							category: 'save'
						},
						OFFICE_WEBSITE_CLICKED: {
							category: 'link',
							segment: 'source'
						},
						PRINT_MEDIA_CLICKED: {
							category: 'print'
						},
						PROPERTY_MAP_CLICKED: {
							category: 'map'
						},
						SHARED_FACEBOOK: {
							category: 'share',
							segment: 'facebook'
						},
						SHARED_LINKEDIN: {
							category: 'share',
							segment: 'linkedin'
						},
						SHARED_TWITTER: {
							category: 'share',
							segment: 'x'
						},
						VIRTUAL_TOUR_CLICKED: {
							category: 'link',
							segment: 'tour'
						}
					},
					preview: {
						SEARCH_DISPLAY: {
							category: 'entry'
						}
					},
					submit: {
						AGENT_EMAIL_SENT: {
							category: 'message'
						}
					},
					view: {
						DETAIL_PAGE_VIEWED: {
							category: 'entry'
						}
					},
					watch: {
						VIDEO_CLICKED: {
							category: 'play'
						}
					}
				}
			},

			/**
			 * Send event data to ListHub
			 *
			 * @param {Object} event
			 * @param {Object} options
			 */
			send(event, options) {
				if (! options.key || options.source !== 'listhub') {
					return;
				}

				const matches = LS.analytics.transform(event, this.map);

				if (! matches) {
					return;
				}

				matches.forEach(match => {
					const data = {
						ep: location.href,
						et: new Date().getTime(),
						ev: $.env() !== 'production' ?
							'QA_' + match : match,
						lkey: options.key,
						mp: 'M-3662',
						v: 3
					};

					setTimeout(() => {
						new Image().src = 'https://tracking.listhub.net/tracker?' +
							$.serialize(data);
					}, match === 'SEARCH_DISPLAY' ? 2000 : 500);
				});
			}
		}
	}
};